var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDepartures = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M22.08 9.248q.144.6-.168 1.128a1.49 1.49 0 0 1-.912.696l-9.648 2.592-5.304 1.392-1.584.48-2.64-4.488 1.464-.384 1.968 1.488 4.968-1.296L6.096 3.68l1.92-.528 6.888 6.432 5.352-1.416q.6-.168 1.14.156t.684.924M2.496 18.584h19.032V20.6H2.496z"
})));
export default SvgDepartures;